import React from 'react';
import { motion } from 'framer-motion';
import { PortfolioConfig } from '../types/config';
import BackgroundAnimation from './BackgroundAnimation';
import { HorizontalCarousel } from './ui/HorizontalCarousel';

interface ProjectsProps {
  config: PortfolioConfig;
}

const Projects: React.FC<ProjectsProps> = ({ config }) => {
  const projectItems = config.projects.map((project, index) => ({
    id: project.name,
    title: project.name,
    description: project.description,
    image: project.image,
    technologies: project.technologies,
    github: project.github,
    type: 'project' as const
  }));
  
  return (
    <section id="projects">
      <HorizontalCarousel
        items={projectItems}
        title="My Projects"
        subtitle="Explore my latest work and innovations"
      />
    </section>
  );
};

export default Projects; 